(function () {
  'use strict';

  var FALLBACK_IMG = 'https://cdn.shopify.com/s/files/1/0686/8995/3069/files/no-image.png';

  var ICONS = {
    diamond: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="21" viewBox="0 0 30 21" fill="none"><mask id="mask0_108_1199" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="30" height="21"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.666992 0H29.0294V21H0.666992V0Z" fill="white"/></mask><g mask="url(#mask0_108_1199)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.3337 5.00243L14.8483 20.2737L28.3622 5.00243L24.8493 0.578427H4.84663L1.3337 5.00243ZM14.8483 21.0002C14.7649 21.0002 14.6862 20.9643 14.6318 20.9024L0.739817 5.20445C0.646625 5.0991 0.642573 4.94224 0.729398 4.83284L4.4808 0.108995C4.53521 0.0401138 4.61914 -0.000404358 4.70713 -0.000404358H24.9888C25.0774 -0.000404358 25.1607 0.0401138 25.2157 0.108995L28.9665 4.83284C29.0539 4.94224 29.0499 5.0991 28.9567 5.20445L15.0647 20.9024C15.0097 20.9643 14.931 21.0002 14.8483 21.0002Z" fill="black"/></g><path fill-rule="evenodd" clip-rule="evenodd" d="M28.7401 5.30204H0.956164C0.796406 5.30204 0.666748 5.17238 0.666748 5.01262C0.666748 4.85286 0.796406 4.72321 0.956164 4.72321H28.7401C28.8998 4.72321 29.0295 4.85286 29.0295 5.01262C29.0295 5.17238 28.8998 5.30204 28.7401 5.30204Z" fill="black"/><mask id="mask1_108_1199" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="4" y="0" width="12" height="6"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.41772 0H15.1376V5.30204H4.41772V0Z" fill="white"/></mask><g mask="url(#mask1_108_1199)"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.50465 5.30203C9.43114 5.30203 9.35762 5.27425 9.30148 5.21868L4.50412 0.49542C4.39009 0.383126 4.38894 0.200216 4.50065 0.0861859C4.61294 -0.0278439 4.79586 -0.0290016 4.91046 0.0827129L9.51565 4.6167L14.6562 0.0722939C14.7749 -0.0330534 14.9578 -0.0226344 15.0649 0.0977625C15.1708 0.217581 15.1598 0.400491 15.04 0.505839L9.69624 5.2291C9.64125 5.27772 9.57295 5.30203 9.50465 5.30203Z" fill="black"/></g><mask id="mask2_108_1199" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="14" y="0" width="12" height="6"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.5586 0H25.2786V5.30204H14.5586V0Z" fill="white"/></mask><g mask="url(#mask2_108_1199)"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.1917 5.30203C20.1234 5.30203 20.0551 5.27772 20.0001 5.2291L14.6563 0.505839C14.5365 0.400491 14.5255 0.217581 14.6308 0.0977625C14.7379 -0.0226344 14.9203 -0.0330534 15.0401 0.0722939L20.1807 4.6167L24.7859 0.0827129C24.9005 -0.0290016 25.0834 -0.0278439 25.1957 0.0861859C25.3074 0.200216 25.3062 0.383126 25.1922 0.49542L20.3943 5.21868C20.3387 5.27425 20.2652 5.30203 20.1917 5.30203Z" fill="black"/></g><path fill-rule="evenodd" clip-rule="evenodd" d="M14.8482 21C14.7243 21 14.6143 20.9213 14.5738 20.8038L9.2306 5.10587C9.17908 4.9548 9.26012 4.79041 9.41119 4.7389C9.56285 4.68622 9.72666 4.76784 9.77875 4.91949L14.8482 19.8122L19.9176 4.91949C19.9691 4.76784 20.1335 4.68622 20.2851 4.7389C20.4362 4.79041 20.5172 4.9548 20.4657 5.10587L15.1225 20.8038C15.082 20.9213 14.972 21 14.8482 21Z" fill="black"/></svg>',
    setting: '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="22" viewBox="0 0 26 22" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.70079 3.49329H20.2992L18.4585 0.506714H7.54152L5.70079 3.49329ZM20.7499 4H5.25011C5.15917 4 5.07523 3.94984 5.03126 3.86927C4.98729 3.7887 4.98979 3.6904 5.03825 3.61236L7.19076 0.119078C7.23623 0.0450975 7.31618 0 7.40262 0H18.5974C18.6833 0 18.7638 0.0450975 18.8087 0.119078L20.9617 3.61236C21.0102 3.6904 21.0127 3.7887 20.9687 3.86927C20.9248 3.94984 20.8408 4 20.7499 4Z" fill="#20192D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.7769 3.48876L9.95009 8.47703C10.3918 8.36119 10.8331 8.27908 11.2923 8.22825C12.3882 8.07136 13.5391 8.06843 14.7199 8.22141C15.1572 8.27713 15.604 8.36022 16.0507 8.46774L16.1756 8.33627L20.2234 3.48876H5.7769ZM9.85964 9C9.78568 9 9.71472 8.96774 9.66624 8.91007L5.05679 3.39883C4.99533 3.326 4.98283 3.22483 5.02381 3.13978C5.06529 3.05425 5.15324 3 5.24969 3H20.7501C20.8466 3 20.9345 3.05425 20.976 3.13978C21.017 3.22483 21.005 3.326 20.944 3.39883L16.3151 8.90665C16.2526 8.97263 16.1572 8.99902 16.0702 8.97654C15.595 8.85631 15.1192 8.7654 14.655 8.70577C13.5186 8.55816 12.4222 8.56012 11.3568 8.7131C10.8626 8.76784 10.3978 8.85826 9.9291 8.99022C9.90611 8.99707 9.88262 9 9.85964 9Z" fill="#20192D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.2813 9C14.2464 9 14.2104 8.99418 14.1761 8.98206C14.032 8.93163 13.9622 8.79052 14.0207 8.66639L16.4135 3.5827L14.7783 0.339207C14.7164 0.216042 14.7823 0.0734816 14.9247 0.0201426C15.0671 -0.0331963 15.2331 0.023052 15.2951 0.145732L16.9769 3.48281C17.0067 3.54245 17.0079 3.61034 16.9792 3.67047L14.5419 8.84871C14.498 8.94278 14.3922 9 14.2813 9Z" fill="#20192D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M11.7194 9C11.6088 9 11.5033 8.94283 11.4595 8.84884L9.02036 3.66735C8.9923 3.60727 8.99342 3.53993 9.02261 3.47986L10.7002 0.145676C10.7619 0.0226187 10.9286 -0.0330963 11.0695 0.0201963C11.2115 0.0734889 11.2766 0.215926 11.2154 0.338499L9.58442 3.57966L11.9793 8.66668C12.0376 8.79022 11.9686 8.93169 11.8249 8.98207C11.7907 8.99419 11.7542 9 11.7194 9Z" fill="#20192D"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.2498 9C10.1409 9 10.0414 8.9216 10.0099 8.80154C9.97143 8.65626 10.0484 8.50441 10.1804 8.46274C10.6772 8.3054 11.169 8.1985 11.6834 8.1349C12.777 7.95837 13.9296 7.95454 15.1112 8.12668C15.548 8.18918 15.9954 8.28237 16.4422 8.40298L16.5677 8.25606C16.6607 8.14477 16.8201 8.13929 16.9206 8.24235C17.0215 8.34542 17.027 8.51921 16.9326 8.6294L16.7066 8.89529C16.6442 8.9693 16.5487 8.99945 16.4617 8.97369C15.9864 8.83937 15.51 8.73685 15.0462 8.66997C13.9091 8.50495 12.811 8.5066 11.7478 8.67874C11.253 8.73959 10.7887 8.84101 10.3193 8.98904C10.2958 8.99671 10.2728 9 10.2498 9Z" fill="#20192D"/><mask id="mask0_108_1214" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="6" width="26" height="16"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 6H26V22H0V6Z" fill="white"/></mask><g mask="url(#mask0_108_1214)"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.0345 22H23.9792C23.4653 22 23.0518 21.6091 23.0166 21.0913C22.7674 17.3844 20.3453 14.0583 16.8455 12.6183C16.5462 12.4943 16.2255 12.3829 15.8916 12.2871C14.9689 12.0086 13.9967 11.8676 12.999 11.8676C11.7469 11.8676 10.5392 12.0884 9.41048 12.5234C9.21472 12.5952 9.02252 12.6739 8.84613 12.7527C5.47224 14.2675 3.22451 17.4627 2.98083 21.0908C2.94565 21.6091 2.53169 22 2.01781 22H0.96353C0.697412 22 0.449647 21.8951 0.267137 21.704C0.0820781 21.5103 -0.0147848 21.2459 0.00152897 20.9774C0.252863 16.8335 2.54953 13.0513 6.14569 10.8601C6.25581 10.7934 6.32718 10.685 6.34503 10.5561C6.36389 10.4226 6.32208 10.2886 6.2293 10.1888L4.732 8.57364C4.37361 8.18628 4.40165 7.58468 4.79522 7.23245L6.09828 6.06538C6.2033 5.97205 6.3644 5.97958 6.45871 6.08194C6.55354 6.1843 6.54589 6.34285 6.44189 6.43617L5.13883 7.60325C4.95275 7.76933 4.93949 8.05332 5.10875 8.23545L6.60605 9.85109C6.80079 10.0613 6.89001 10.3433 6.85024 10.6253C6.81099 10.9003 6.65193 11.1416 6.41436 11.2871C2.95839 13.392 0.751451 17.0261 0.510824 21.007C0.502667 21.138 0.549569 21.2669 0.638275 21.3603C0.723412 21.4491 0.839138 21.4982 0.96353 21.4982H2.01781C2.25945 21.4982 2.45522 21.3091 2.47204 21.0577C2.72796 17.2449 5.08938 13.8877 8.63507 12.2961C8.82115 12.2128 9.02456 12.13 9.22746 12.0548C10.4128 11.5982 11.6832 11.3659 12.999 11.3659C14.0471 11.3659 15.0698 11.5144 16.0384 11.8064C16.3872 11.9068 16.7262 12.0247 17.0423 12.1556C20.7185 13.6684 23.2634 17.1626 23.5254 21.0582C23.5423 21.3091 23.7375 21.4982 23.9792 21.4982H25.0345C25.1614 21.4982 25.2843 21.4461 25.3714 21.3552C25.454 21.2695 25.4958 21.1591 25.4897 21.0447C25.2532 16.9318 22.9483 13.2259 19.3257 11.1311C19.0764 10.9871 18.9092 10.7437 18.8658 10.4627C18.822 10.1797 18.9092 9.89575 19.1054 9.68401L20.3014 8.3905C20.4544 8.22542 20.539 8.05884 20.5456 7.90881C20.5512 7.7894 20.5074 7.68654 20.4146 7.60375L19.111 6.43617C19.007 6.34285 18.9994 6.1843 19.0942 6.08194C19.189 5.97958 19.3501 5.97205 19.4546 6.06538L20.7582 7.23296C20.9621 7.41559 21.0677 7.66396 21.0549 7.9319C21.0427 8.20033 20.9122 8.47579 20.6787 8.72868L19.4827 10.0212C19.3909 10.121 19.3496 10.2545 19.37 10.3875C19.3904 10.5184 19.4679 10.6313 19.5836 10.6986C23.3541 12.8782 25.7523 16.7356 25.9985 21.0166C26.0128 21.27 25.9215 21.5128 25.7421 21.7C25.559 21.8906 25.3006 22 25.0345 22Z" fill="#20192D"/></g></svg>',
    complete: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="26" viewBox="0 0 20 26" fill="none"><mask id="mask0_108_1175" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="0" width="13" height="8"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.91895 0.5H15.421V7.29588H3.91895V0.5Z" fill="white"/></mask><g mask="url(#mask0_108_1175)"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.66844 6.6571C10.1623 6.6571 10.6464 6.69384 11.111 6.76629L14.828 2.59791L13.5567 1.01015H5.78324L4.51201 2.59791L8.22641 6.76425C8.69508 6.69282 9.17971 6.6571 9.66844 6.6571ZM11.2093 7.29588C11.1948 7.29588 11.1799 7.29486 11.165 7.29231C10.2138 7.127 9.14524 7.12649 8.17034 7.28976C8.08339 7.30455 7.99388 7.27292 7.93471 7.2071L3.98314 2.77597C3.90083 2.68311 3.89723 2.54485 3.97491 2.44842L5.45759 0.596375C5.50646 0.535661 5.58106 0.499947 5.65925 0.499947H13.6807C13.7589 0.499947 13.8335 0.535661 13.8819 0.596375L15.3651 2.44842C15.4427 2.54485 15.4391 2.68311 15.3568 2.77597L11.4022 7.20965C11.3523 7.26527 11.2823 7.29588 11.2093 7.29588Z" fill="black"/></g><path fill-rule="evenodd" clip-rule="evenodd" d="M15.1646 2.86271H4.17471C4.03221 2.86271 3.91748 2.74842 3.91748 2.6076C3.91748 2.46679 4.03221 2.3525 4.17471 2.3525H15.1646C15.3066 2.3525 15.4218 2.46679 15.4218 2.6076C15.4218 2.74842 15.3066 2.86271 15.1646 2.86271Z" fill="black"/><mask id="mask1_108_1175" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="6" width="20" height="20"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.169922 6.65767H19.1699V25.5H0.169922V6.65767Z" fill="white"/></mask><g mask="url(#mask1_108_1175)"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.6684 7.16731C9.15909 7.16731 8.65492 7.20863 8.1703 7.28976C3.83237 8.01221 0.684382 11.7081 0.684382 16.077C0.684382 20.9918 4.71467 24.9898 9.6684 24.9898C14.6237 24.9898 18.6555 20.9918 18.6555 16.077C18.6555 11.7066 15.506 8.01221 11.167 7.29282C10.6865 7.20914 10.1834 7.16731 9.6684 7.16731ZM9.6684 25.5C4.43068 25.5 0.169922 21.2729 0.169922 16.077C0.169922 11.4581 3.499 7.55047 8.0849 6.78618C9.11639 6.61373 10.2446 6.61475 11.2535 6.78975C15.8399 7.55047 19.17 11.4561 19.17 16.077C19.17 21.2729 14.9077 25.5 9.6684 25.5Z" fill="black"/></g><path fill-rule="evenodd" clip-rule="evenodd" d="M9.66873 9.91191C9.31632 9.91191 8.96803 9.94048 8.63157 9.9966C5.6297 10.4966 3.45147 13.0543 3.45147 16.0777C3.45147 19.4788 6.24036 22.2451 9.66873 22.2451C13.0981 22.2451 15.888 19.4788 15.888 16.0777C15.888 13.0532 13.7088 10.4966 10.7059 9.99864C10.3725 9.94099 10.0242 9.91191 9.66873 9.91191ZM9.66873 22.7553C5.95689 22.7553 2.93701 19.7599 2.93701 16.0777C2.93701 12.8043 5.29633 10.0349 8.54617 9.49354C9.27928 9.37058 10.0757 9.3716 10.7923 9.49558C14.0422 10.0349 16.4025 12.8032 16.4025 16.0777C16.4025 19.7599 13.3816 22.7553 9.66873 22.7553Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.66828 7.16731C9.57979 7.16731 9.49388 7.12241 9.44603 7.04078L6.90923 2.73618C6.84287 2.62342 6.8727 2.47954 6.97868 2.40199L9.51754 0.549436C9.63073 0.466783 9.79278 0.489742 9.87664 0.604028C9.96101 0.717294 9.93632 0.876988 9.82211 0.960662L7.47051 2.67699L9.89053 6.78363C9.96204 6.90506 9.92088 7.06118 9.79793 7.13261C9.75728 7.15608 9.71253 7.16731 9.66828 7.16731Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.67159 7.16731C9.62734 7.16731 9.58259 7.15609 9.54194 7.13262C9.4195 7.06119 9.37783 6.90507 9.44934 6.78364L11.8699 2.677L9.51776 0.960666C9.40355 0.876993 9.37886 0.717298 9.46323 0.604033C9.5476 0.490257 9.70914 0.466788 9.82233 0.549441L12.3607 2.402C12.4667 2.47955 12.4965 2.62342 12.4301 2.73618L9.89384 7.04078C9.84599 7.12241 9.76008 7.16731 9.67159 7.16731Z" fill="black"/></svg>'
  };

  function getParams() {
    var urlParams = new URLSearchParams(window.location.search);
    var steps = '';
    var review = '';
    // Match Liquid: any param name containing "steps" / "review"
    urlParams.forEach(function (_value, key) {
      if (!steps && key.indexOf('steps') !== -1) steps = urlParams.get(key) || 'settings';
      if (!review && key.indexOf('review') !== -1) review = urlParams.get(key) || 'true';
    });
    return {
      stoneStock: urlParams.get('stone-stock') || '',
      vendorId: urlParams.get('vendorId') || '',
      ringHandle: urlParams.get('ring-handle') || '',
      stoneShape: urlParams.get('stone_shape') || '',
      steps: steps,
      review: review
    };
  }

  function getShapeHandle(stoneShape, fallback) {
    if (stoneShape) {
      return stoneShape.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-engagement-rings';
    }
    return fallback || 'engagement-rings';
  }

  function vendorQuery(vendorId) {
    return vendorId ? '&vendorId=' + encodeURIComponent(vendorId) : '';
  }

  function shapeQuery(stoneShape) {
    return stoneShape ? '&stone_shape=' + encodeURIComponent(stoneShape) : '';
  }

  function collectionUrl(shapeHandle) {
    return '/collections/' + shapeHandle;
  }

  async function fetchRingProduct(handle) {
    if (!handle) return null;
    try {
      var res = await fetch('/products/' + handle + '.js');
      if (!res.ok) return null;
      var product = await res.json();
      return {
        handle: product.handle,
        price: product.price,
        image: (product.media && product.media.length > 0 && product.media[0].preview_image)
          ? product.media[0].preview_image.src
          : (product.featured_image ? product.featured_image : FALLBACK_IMG)
      };
    } catch (e) {
      return null;
    }
  }

  async function fetchStoneData(stockNum, vendorId) {
    if (!stockNum) return null;
    try {
      var appProxy = (typeof baseAppProxy !== 'undefined') ? baseAppProxy : '/apps/vdb';
      var shop = (typeof Shopify !== 'undefined' && Shopify.shop) ? Shopify.shop : '';
      var formData = new FormData();
      formData.append('action', 'get_stone_details');
      formData.append('shop', shop);
      formData.append('labgrown_stock_num', stockNum);
      formData.append('vendor_id', vendorId);

      var res = await fetch(appProxy + '/frontend.php', { method: 'POST', body: formData });
      var data = await res.json();
      if (data && data.success && data.data && Object.keys(data.data).length > 0) {
        return {
          image: data.data.image_url || FALLBACK_IMG,
          price: Number(data.data.total_sales_price) * 100
        };
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  function waitForCurrency(timeoutMs) {
    return new Promise(function (resolve) {
      if (typeof Currency !== 'undefined' && Currency.rates && Currency.convert) {
        resolve(true);
        return;
      }
      var started = Date.now();
      var timer = setInterval(function () {
        if (typeof Currency !== 'undefined' && Currency.rates && Currency.convert) {
          clearInterval(timer);
          resolve(true);
        } else if (Date.now() - started > (timeoutMs || 3000)) {
          clearInterval(timer);
          resolve(false);
        }
      }, 50);
    });
  }

  function getMoneyFormat() {
    var container = document.getElementById('vdb-stepper');
    return (container && container.getAttribute('data-money-format')) || '{{amount}}';
  }

  function getActiveCurrency() {
    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    var container = document.getElementById('vdb-stepper');
    return (container && container.getAttribute('data-currency')) || 'USD';
  }

  /**
   * Matches Liquid | money for settings, and original stone script:
   * HackWrapper.formatMoney(HackWrapper.convertToShopCurrency(usdCents))
   */
  function formatMoney(cents, fromUsd) {
    var amountCents = Number(cents) || 0;
    var moneyFormat = getMoneyFormat();

    if (fromUsd) {
      if (typeof HackWrapper !== 'undefined' && HackWrapper.convertToShopCurrency) {
        amountCents = HackWrapper.convertToShopCurrency(amountCents);
      } else if (typeof Currency !== 'undefined' && Currency.convert) {
        var activeCurrency = getActiveCurrency();
        if (activeCurrency !== 'USD') {
          amountCents = Currency.convert(amountCents / 100, 'USD', activeCurrency) * 100;
        }
      }
    }

    if (typeof HackWrapper !== 'undefined' && HackWrapper.formatMoney) {
      return HackWrapper.formatMoney(amountCents, moneyFormat);
    }
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (amountCents / 100).toFixed(2));
  }

  function buildProductLinks(type, data) {
    var fromUsd = type === 'diamond';
    return '<div class="steps-links">' +
      '<div class="change_view_img">' +
        '<img src="' + (data.image || FALLBACK_IMG) + '" onerror="this.src=\'' + FALLBACK_IMG + '\'" />' +
      '</div>' +
      '<div class="change-view">' +
        '<div class="change_view_price">' + formatMoney(data.price, fromUsd) + '</div>' +
        '<div class="chnage_view_links">' +
          '<a href="' + data.changeUrl + '" class="step-link">Change</a> ' +
          '<a href="' + data.viewUrl + '" class="step-link">View</a>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function renderStep(step) {
    var classes = ['step'];
    if (step.active) classes.push('active-step');
    if (step.activeMobile) classes.push('active-step-mobile');
    if (step.type === 'setting') classes.push('setting-step');
    if (step.type === 'diamond') classes.push('diamond-step');
    if (step.type === 'complete') {
      classes.push('lst-step');
      classes.push('lst-step-testing');
      classes.push('preview-step');
    }

    var titleInner = '';
    if (step.type === 'setting') {
      titleInner = '<span class="step-title"><span class="hidden--mobile">Choose Your </span>Setting</span>';
    } else if (step.type === 'diamond') {
      titleInner = '<span class="step-title"><span class="hidden--mobile">Choose Your </span>Stone</span>';
    } else {
      titleInner = '<span class="step-title">Review <span class="hidden--mobile">& Finish</span></span>';
    }

    if (step.titleHref) {
      titleInner = '<a href="' + step.titleHref + '">' + titleInner + '</a>';
    }

    var iconHtml = '';
    if (step.productData) {
      iconHtml = buildProductLinks(step.type, step.productData);
    } else {
      var iconKey = step.type === 'diamond' ? 'diamond' : (step.type === 'setting' ? 'setting' : 'complete');
      iconHtml = ICONS[iconKey];
    }

    var titleWrapper = step.type === 'complete'
      ? '<div class="step-content-inner"><span class="step-number">' + step.number + '</span>' + titleInner + '</div>'
      : '<div class="step-content-inner"><span class="step-number">' + step.number + '</span><div><div>' + titleInner + '</div></div></div>';

    var iconTag = '<span class="step-icon">' + iconHtml + '</span>';

    if (step.type === 'complete') {
      return '<div class="' + classes.join(' ') + '">' +
        '<div class="step-content">' + titleWrapper + '</div>' +
        iconTag +
      '</div>';
    }
    return '<div class="' + classes.join(' ') + '">' +
      '<div class="step-content">' + titleWrapper + iconTag + '</div>' +
    '</div>';
  }

  function step(type, number, opts) {
    opts = opts || {};
    return {
      type: type,
      number: number,
      active: !!opts.active,
      activeMobile: !!opts.activeMobile,
      titleHref: opts.titleHref || null,
      productData: opts.productData || null
    };
  }

  function settingCard(product, changeUrl, viewUrl) {
    if (!product || !product.handle) return null;
    return {
      image: product.image || FALLBACK_IMG,
      price: product.price || 0,
      changeUrl: changeUrl,
      viewUrl: viewUrl
    };
  }

  function stoneCard(stoneData, changeUrl, viewUrl) {
    if (!stoneData) return null;
    return {
      image: stoneData.image || FALLBACK_IMG,
      price: stoneData.price || 0,
      changeUrl: changeUrl,
      viewUrl: viewUrl
    };
  }

  /**
   * Mirror A:\Store themes\CLAIRAMOR-Live\stepper.liquid exactly.
   * Flow from URL query params only.
   * Only intentional deviation: stone-pdp + steps setting step number is 2 (Liquid duplicates 1).
   */
  function buildSteps(template, params, pageProduct, ringProduct, stoneData) {
    var shapeHandle = getShapeHandle(params.stoneShape, pageProduct.shapeHandle);
    var col = collectionUrl(shapeHandle);
    // Liquid: selectRingProduct = all_products[ringHandle] (only when product resolves)
    var hasRing = !!ringProduct;
    var hasStone = !!params.stoneStock;
    var hasPageProduct = !!pageProduct.handle;
    var isSteps = !!params.steps;
    var isReview = !!params.review;
    var vq = vendorQuery(params.vendorId);
    var sq = shapeQuery(params.stoneShape);
    var selectedSetting = ringProduct || (hasPageProduct ? pageProduct : null);

    // ---------- collection.vdb-stone-plp ----------
    if (template === 'collection.vdb-stone-plp') {
      if (hasRing) {
        return [
          step('setting', 1, {
            active: true,
            titleHref: col,
            productData: settingCard(ringProduct, col, col + '/products/' + ringProduct.handle)
          }),
          // Liquid: stoneStock blank OR selectedSetting blank → SVG (selectedSetting unset)
          step('diamond', 2, { active: true, activeMobile: true, productData: null }),
          step('complete', 3, {})
        ];
      }
      return [
        step('diamond', 1, {
          active: true,
          activeMobile: true,
          productData: hasStone ? stoneCard(
            stoneData,
            '/collections/stones',
            '/products/stone-details?stone-stock=' + encodeURIComponent(params.stoneStock) + vq + sq
          ) : null
        }),
        step('setting', 2, { titleHref: col, productData: null }),
        step('complete', 3, {})
      ];
    }

    // ---------- product.vdb-stone-pdp ----------
    if (template === 'product.vdb-stone-pdp') {
      // selectRingProduct != blank AND isStepsSettingPage == No
      if (hasRing && !isSteps) {
        return [
          step('setting', 1, {
            active: true,
            titleHref: col,
            productData: settingCard(ringProduct, col, col + '/products/' + ringProduct.handle)
          }),
          step('diamond', 2, { active: true, activeMobile: true, productData: null }),
          step('complete', 3, {})
        ];
      }
      // selectRingProduct != blank AND isStepsSettingPage == Yes
      if (hasRing && isSteps) {
        var settingQs = '';
        if (hasStone) settingQs += '?stone-stock=' + encodeURIComponent(params.stoneStock) + vq;
        if (params.stoneShape) settingQs += (settingQs ? '&' : '?') + 'stone_shape=' + encodeURIComponent(params.stoneShape);
        settingQs += (settingQs ? '&' : '?') + 'steps=settings';
        return [
          step('diamond', 1, { active: true, productData: null }),
          step('setting', 2, {
            active: true,
            productData: settingCard(
              ringProduct,
              col + settingQs,
              col + '/products/' + ringProduct.handle + settingQs
            )
          }),
          step('complete', 3, {})
        ];
      }
      // else — no ring
      return [
        step('diamond', 1, {
          active: true,
          activeMobile: true,
          titleHref: '/collections/stones',
          // Liquid: SVG if stoneStock blank OR isStepsSettingPage == Yes
          productData: (!hasStone || isSteps) ? null : stoneCard(
            stoneData,
            '/collections/stones',
            '/products/stone-details?stone-stock=' + encodeURIComponent(params.stoneStock) + vq + sq
          )
        }),
        step('setting', 2, { titleHref: col, productData: null }),
        step('complete', 3, {})
      ];
    }

    // ---------- collection.vdb-setting-plp ----------
    if (template === 'collection.vdb-setting-plp') {
      // selectRingProduct != blank OR (product != blank AND isStepsSettingPage == No)
      if (hasRing || (hasPageProduct && !isSteps)) {
        var setting = selectedSetting;
        return [
          step('setting', 1, {
            active: true,
            productData: setting ? settingCard(setting, col, col + '/products/' + setting.handle) : null
          }),
          step('diamond', 2, {
            active: hasStone,
            // Liquid: plain title; Change = /collections/stones
            productData: hasStone && setting ? stoneCard(
              stoneData,
              '/collections/stones',
              '/products/stone-details?stone-stock=' + encodeURIComponent(params.stoneStock) + vq + sq +
                '&ring-handle=' + encodeURIComponent(setting.handle)
            ) : null
          }),
          step('complete', 3, { active: isReview })
        ];
      }
      // stoneStock != blank AND isStepsSettingPage == Yes
      if (hasStone && isSteps) {
        var stoneViewPlp = '/products/stone-details?stone-stock=' + encodeURIComponent(params.stoneStock) + vq + sq;
        if (params.steps) stoneViewPlp += '&steps=' + encodeURIComponent(params.steps);
        if (hasPageProduct) stoneViewPlp += '&ring-handle=' + encodeURIComponent(pageProduct.handle);
        return [
          step('diamond', 1, {
            active: true,
            titleHref: '/collections/stones',
            productData: stoneCard(stoneData, '/collections/stones', stoneViewPlp)
          }),
          // Liquid: SVG if product blank OR isReviewPage == No
          step('setting', 2, {
            active: true,
            activeMobile: true,
            productData: (hasPageProduct && isReview)
              ? settingCard(pageProduct, col, col + '/products/' + pageProduct.handle)
              : null
          }),
          step('complete', 3, { active: isReview })
        ];
      }
      // else — bare setting PLP
      return [
        step('setting', 1, { active: true, activeMobile: true, productData: null }),
        step('diamond', 2, { titleHref: '/collections/stones', productData: null }),
        step('complete', 3, {})
      ];
    }

    // ---------- product.vdb-setting-pdp ----------
    if (template === 'product.vdb-setting-pdp') {
      // product + review + no steps
      if (hasPageProduct && isReview && !isSteps) {
        var settingA = ringProduct || pageProduct;
        var viewSettingA = col + '/products/' + settingA.handle +
          '?stone-stock=' + encodeURIComponent(params.stoneStock) + vq + sq;
        // Liquid Change: /collections/stones?ring-handle=...&review=true
        var stoneChangeA = '/collections/stones?ring-handle=' + encodeURIComponent(settingA.handle) + '&review=true';
        var stoneViewA = '/products/stone-details?stone-stock=' + encodeURIComponent(params.stoneStock) +
          vq + sq + '&ring-handle=' + encodeURIComponent(settingA.handle) + '&review=true';
        return [
          step('setting', 1, {
            active: true,
            titleHref: col,
            productData: settingCard(settingA, col, viewSettingA)
          }),
          step('diamond', 2, {
            active: hasStone,
            titleHref: '/collections/stones',
            productData: hasStone ? stoneCard(stoneData, stoneChangeA, stoneViewA) : null
          }),
          step('complete', 3, { active: true })
        ];
      }

      // stoneStock != blank AND isStepsSettingPage == No  (Setting → Stone)
      if (hasStone && !isSteps) {
        return [
          step('setting', 1, {
            active: true,
            // Liquid: SVG when product blank OR isReviewPage == No
            productData: (hasPageProduct && isReview)
              ? settingCard(pageProduct, col, col + '/products/' + pageProduct.handle)
              : null
          }),
          step('diamond', 2, {
            active: true,
            // Liquid: plain titles; Change = /collections/stones; View omits vendorId
            productData: stoneCard(
              stoneData,
              '/collections/stones',
              '/products/stone-details?stone-stock=' + encodeURIComponent(params.stoneStock) +
                sq + (hasPageProduct ? '&ring-handle=' + encodeURIComponent(pageProduct.handle) : '')
            )
          }),
          step('complete', 3, { active: isReview })
        ];
      }

      // stoneStock != blank AND isStepsSettingPage == Yes  (Stone → Setting)
      if (hasStone && isSteps) {
        var stoneViewC = '/products/stone-details?stone-stock=' + encodeURIComponent(params.stoneStock) +
          vq + sq +
          (hasPageProduct ? '&ring-handle=' + encodeURIComponent(pageProduct.handle) : '') +
          '&steps=settings' + (isReview ? '&review=true' : '');
        var settingChangeC = col + '?stone-stock=' + encodeURIComponent(params.stoneStock) + vq + sq +
          '&steps=settings' + (isReview ? '&review=true' : '');
        var settingViewC = col + '/products/' + pageProduct.handle +
          '?stone-stock=' + encodeURIComponent(params.stoneStock) + vq + sq + '&steps=settings';
        return [
          step('diamond', 1, {
            active: true,
            titleHref: '/collections/stones',
            productData: stoneCard(stoneData, '/collections/stones', stoneViewC)
          }),
          step('setting', 2, {
            active: true,
            activeMobile: !isReview,
            titleHref: col,
            // Liquid: SVG if product blank OR isReviewPage == No
            productData: (hasPageProduct && isReview)
              ? settingCard(pageProduct, settingChangeC, settingViewC)
              : null
          }),
          step('complete', 3, { active: isReview })
        ];
      }

      // else — setting PDP, no stone yet
      return [
        step('setting', 1, {
          active: true,
          activeMobile: true,
          titleHref: col,
          productData: null
        }),
        step('diamond', 2, {
          titleHref: '/collections/stones',
          productData: null
        }),
        step('complete', 3, {})
      ];
    }

    return [
      step('setting', 1, { active: true, activeMobile: true, titleHref: '/collections/engagement-rings', productData: null }),
      step('diamond', 2, { titleHref: '/collections/stones', productData: null }),
      step('complete', 3, {})
    ];
  }

  async function init() {
    var container = document.getElementById('vdb-stepper');
    if (!container) return;

    var template = container.getAttribute('data-template') || '';
    var pageProduct = {
      handle: container.getAttribute('data-product-handle') || '',
      price: parseInt(container.getAttribute('data-product-price') || '0', 10),
      image: container.getAttribute('data-product-image') || '',
      shapeHandle: container.getAttribute('data-shape-handle') || 'engagement-rings'
    };

    var params = getParams();
    await waitForCurrency(3000);

    var results = await Promise.all([
      fetchRingProduct(params.ringHandle),
      fetchStoneData(params.stoneStock, params.vendorId)
    ]);
    var ringProduct = results[0];
    var stoneData = results[1];

    var steps = buildSteps(template, params, pageProduct, ringProduct, stoneData);
    container.innerHTML = '<div class="stepper">' + steps.map(renderStep).join('') + '</div>';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();